function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrdersList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "25px",
    width: "25px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 285.102 285.102",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(69, 110, 141)"
    },
    d: "M220.741,46.137h-30.188v-5.785c0-7.444-6.056-13.5-13.5-13.5h-1.667 C172.294,11.554,158.748,0,142.552,0c-16.196,0-29.743,11.554-32.835,26.852h-1.669c-7.444,0-13.5,6.056-13.5,13.5v5.785H64.36 c-12.407,0-22.5,10.094-22.5,22.5v193.965c0,12.406,10.093,22.5,22.5,22.5h156.381c12.406,0,22.5-10.094,22.5-22.5V68.637 C243.241,56.23,233.148,46.137,220.741,46.137z M109.548,41.852h66.006v24.571h-66.006V41.852z M142.552,15 c7.856,0,14.566,4.931,17.245,11.852h-34.489C127.986,19.931,134.696,15,142.552,15z M228.241,262.602c0,4.136-3.364,7.5-7.5,7.5 H64.36c-4.136,0-7.5-3.364-7.5-7.5V68.637c0-4.136,3.364-7.5,7.5-7.5h30.188v6.786c0,7.444,6.056,13.5,13.5,13.5h69.006 c7.444,0,13.5-6.056,13.5-13.5v-6.786h30.188c4.136,0,7.5,3.364,7.5,7.5V262.602z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(69, 110, 141)"
    },
    d: "M193.212,107.931H91.89c-4.142,0-7.5,3.357-7.5,7.5c0,4.142,3.358,7.5,7.5,7.5h101.322 c4.143,0,7.5-3.358,7.5-7.5C200.712,111.288,197.355,107.931,193.212,107.931z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(69, 110, 141)"
    },
    d: "M193.212,145.26H91.89c-4.142,0-7.5,3.357-7.5,7.5c0,4.143,3.358,7.5,7.5,7.5h101.322 c4.143,0,7.5-3.357,7.5-7.5C200.712,148.617,197.355,145.26,193.212,145.26z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(69, 110, 141)"
    },
    d: "M193.212,182.591H91.89c-4.142,0-7.5,3.357-7.5,7.5c0,4.143,3.358,7.5,7.5,7.5h101.322 c4.143,0,7.5-3.357,7.5-7.5C200.712,185.948,197.355,182.591,193.212,182.591z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(69, 110, 141)"
    },
    d: "M193.212,231.263h-31.28c-4.143,0-7.5,3.357-7.5,7.5c0,4.143,3.357,7.5,7.5,7.5h31.28 c4.143,0,7.5-3.357,7.5-7.5C200.712,234.62,197.355,231.263,193.212,231.263z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrdersList);
export default __webpack_public_path__ + "static/media/ordersList.03eecab88175ed85b7c906fb111803a8.svg";
export { ForwardRef as ReactComponent };